module.exports = __webpack_public_path__ + "img/1.a3ba9363.png";